import { CardBody } from '@chakra-ui/react';
import type { MouseEventHandler, ReactNode } from 'react';

import { useGaChartPreviewMeta } from '../../../global-ai-assistant/ga-chart-preview-meta-context';
import { GLOBAL_AI_INLINE_CHART_PLOT_HEIGHT } from '../../constants/panelWidths';
import { ChartCard } from './ChartRoot/Chart';

export const ChartCardShell = ({
  onClick,
  children,
}: {
  onClick?: MouseEventHandler<HTMLDivElement>;
  children: ReactNode;
}) => {
  const gaChartPreviewMeta = useGaChartPreviewMeta();
  const isGlobalAiChartPreview = gaChartPreviewMeta !== null;

  return (
    <ChartCard onClick={onClick}>
      <CardBody
        data-testid="card-body"
        padding="0.5rem 14px 0.5rem"
        {...(isGlobalAiChartPreview
          ? {
              height: 'auto',
              minHeight: GLOBAL_AI_INLINE_CHART_PLOT_HEIGHT,
              overflow: 'visible',
              position: 'relative',
            }
          : {
              height: '100%',
              minHeight: '120px',
            })}
      >
        {children}
      </CardBody>
    </ChartCard>
  );
};
